export default {
  list: (state) => {
    return state.list;
  },
  listForFilter: (state) => {
    let list = state.list;
    list.unshift({ name: "All Categories", id: "0", children: [] });
    return list;
  },
  listAdmin: (state) => {
    return state.listAdmin;
  },
  subCategoryList: (state) => {
    let subCategoryList = [];
    state.list.forEach((element) => {
      element.children.forEach((child) => {
        subCategoryList.push(child);
      });
    });
    return subCategoryList;
  },
  byName: (state) => {
    // return state.byName
    let byName = {
      "0": {
        children: [],
      },
    };
    state.list.forEach((cat) => {
      byName[cat.id] = cat;
    });
    return byName;
  },
  subCatByName: (state) => {
    let byName = {
      "0": {
        children: [],
      },
    };
    state.list.forEach((cat) => {
      cat.children.forEach((subCat) => {
        byName[subCat.id] = subCat;
      });
    });
    return byName;
  },
};
